import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IHotspot } from "@models/entity-models";
import { Utils } from "@tools";

@Kbo(CToken.Hotspot)
export class Hotspot extends KbObject implements IHotspot {
    constructor(kom: KbObjectManager) {
        super(kom);
        this.$uid = Utils.shortId();
    }
    public target: boolean;
    public targetNode: string;
    public popupPosition: string;
    public popupAttach: string;
    public popupOffsetX: number;
    public popupOffsetY: number;
    public keepPopupInViewer: boolean;
    public idCamera: string;
    public open: boolean;
    public sourceId: string;
    public source: string;
    public popupTop: string;
    public popupLeft: string;
    public popupBottom: string;
    public popupRight: string;
    public popupWidth: string;
    public popupHeight: string;
    public visible: boolean;
    public alpha: number;
    public animationDuration: number;
    public animationEasing: string;
    public allowClose: boolean;
    public targetColor: string;
    public showPopupHeader: boolean;
    public targetShape: string;
    public targetSize: number;
    public targetText: string;
    public targetImage: string;

    public $left: number;
    public $top: number;
    public $hover: boolean;
    public $zindex: number;
    public $uid: string; //used for performance of ng-repeat for nested hotspots
}
